function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.4939 9.89449L16.5184 13.7376C16.7945 14.2616 17.5307 14.7857 18.1442 14.873L21.8099 15.4553C24.1565 15.8338 24.7086 17.435 23.0215 19.0363L20.1687 21.7439C19.6933 22.1952 19.4172 23.0832 19.5706 23.7237L20.3835 27.0864C21.0277 29.7357 19.5399 30.7693 17.0706 29.3864L13.635 27.4503C13.0061 27.1009 11.9939 27.1009 11.3651 27.4503L7.92946 29.3864C5.46013 30.7693 3.97239 29.7357 4.61656 27.0864L5.42949 23.7237C5.58287 23.0977 5.30677 22.2098 4.83131 21.7439L1.97857 19.0363C0.291453 17.435 0.843567 15.8192 3.19019 15.4553L6.85586 14.873C7.46936 14.7711 8.20555 14.2616 8.48163 13.7376L10.5062 9.89449C11.5951 7.81284 13.4049 7.81284 14.4939 9.89449Z",
    stroke: "#D1D1D1",
    style: {
      stroke: "#D1D1D1",
      stroke: "color(display-p3 0.8201 0.8201 0.8201)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29761 11.1899V1",
    stroke: "#D1D1D1",
    style: {
      stroke: "#D1D1D1",
      stroke: "color(display-p3 0.8201 0.8201 0.8201)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7024 11.1899V1",
    stroke: "#D1D1D1",
    style: {
      stroke: "#D1D1D1",
      stroke: "color(display-p3 0.8201 0.8201 0.8201)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.91141V1",
    stroke: "#D1D1D1",
    style: {
      stroke: "#D1D1D1",
      stroke: "color(display-p3 0.8201 0.8201 0.8201)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.17969ff16bdde8068ec22604d2adb1d7.svg";
export { ForwardRef as ReactComponent };